import Vue from 'vue'
import Router from 'vue-router'
import {
  getTeacherLoginState,
  getTeacherLoginPath,
  getTeacherToken,
  rememberTeacherLoginRedirect,
  resolveTeacherLoginState,
  setTeacherLoginState
} from '../utils/teacherAuth'
import newPage from '../pages/new'
import oldPage from '../pages/old'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const routes = [
  // 默认登陆
  {
    path: '/',
    redirect: ''
  },
  //测试jsbridge交互
  {
    path: '/jsbridgeTest',
    name: 'jsbridgeTest',
    component: () => import( /* webpackChunkName:'newLogin'*/ '@/pages/jsbridgeTest/index'),
    meta: {
      title: ''
    }
  },
  //新登录
  {
    path: '/newLogin',
    name: 'newLogin',
    component: () => import( /* webpackChunkName:'newLogin'*/ '@/pages/newLogin/newLogin'),
    meta: {
      title: ''
    }
  },
    // 旧登录
  {
    path: '/oldLogin',
    name: 'oldLogin',
    component: () => import( /* webpackChunkName:'newLogin'*/ '@/pages/oldLogin/oldLogin'),
    meta: {
      title: ''
    }
  },
    // 新页面
  {
    path: '/new/',
    name: 'new',
    component: newPage,
    meta: {
      title: '',
      requireAuth: true
    },
    children:[
        // 为new没值时
      {
        path: '',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/report/report'),
        meta: {
          title: '练习报告',
          requireAuth: true
        }
      },
      // 练习报告
      {
        path: 'report',
        name: 'report',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/report/report'),
        meta: {
          title: '练习报告',
          requireAuth: true
        }
      },
      // 邀请二维码
      {
        path: 'newInvitationCode',
        name: 'newInvitationCode',
        component: () => import( /* webpackChunkName:'newInvitationCode'*/ '@/pages/newInvitationCode/newInvitationCode'),
        meta: {
          title: '个人中心',
          requireAuth: true
        }
      },
      // 我的
      {
        path: 'newPersonalCenter',
        name: 'newPersonalCenter',
        component: () => import( /* webpackChunkName:'newPersonalCenter'*/ '@/pages/newPersonalCenter/newPersonalCenter'),
        meta: {
          title: '个人中心',
          requireAuth: true
        }
      },
      // 消息
      {
        path: 'newPushMessage',
        name: 'newPushMessage',
        component: () => import( /* webpackChunkName:'newPushMessage'*/ '@/pages/newPushMessage/newPushMessage'),
        meta: {
          title: '个人中心',
          requireAuth: true
        }
      },
      // 发布作业
      {
        path: 'releaseHomework',
        name: 'releaseHomework',
        component: () => import( /* webpackChunkName:'releaseHomework'*/ '@/pages/releaseHomework/index'),
        meta: {
          title: '发布作业',
          requireAuth: true
        },
        children:[
          // 发布作业
          {
            path: '',
            name: 'releaseHomeworkList',
            component: () => import( /* webpackChunkName:'releaseHomeworkList'*/ '@/pages/releaseHomework/releaseHomeworkList'),
            meta: {
              title: '发布作业',
              requireAuth: true
            }
          },
          // 发布作业
          {
            path: 'releaseHomework',
            name: 'releaseHomework',
            component: () => import( /* webpackChunkName:'releaseHomework'*/ '@/pages/releaseHomework/releaseHomework'),
            meta: {
              title: '发布作业',
              requireAuth: true
            }
          },
        ]
      },
      // 管理学员
      {
        path: 'studentM',
        name: 'studentM',
        component: () => import( /* webpackChunkName:'index'*/ '@/pages/studentM/index'),
        meta: {
          title: '我的学员',
          requireAuth: true
        },
        children:[
          // 学员信息编辑
          {
            path: '',
            name: 'studentM',
            component: () => import( /* webpackChunkName:'studentM'*/ '@/pages/studentM/studentM'),
            meta: {
              title: '我的学员',
              requireAuth: true
            }
          },
          // 学员信息编辑
          {
            path: 'studentProfile',
            name: 'studentProfile',
            component: () => import( /* webpackChunkName:'studentProfile'*/ '@/pages/studentM/studentProfile'),
            meta: {
              title: '我的学员',
              // requireAuth: true
            }
          },
          // 组信息
          {
            path: 'groupInfo',
            name: 'groupInfo',
            component: () => import( /* webpackChunkName:'groupInfo'*/ '@/pages/studentM/groupInfo'),
            meta: {
              title: '我的学员',
              // requireAuth: true
            }
          },
          // 添加学生
          {
            path: 'addStudent',
            name: 'addStudent',
            component: () => import( /* webpackChunkName:'addStudent'*/ '@/pages/studentM/addStudent'),
            meta: {
              title: '我的学员',
              // requireAuth: true
            }
          },
        ]
      },
      // // 我的学员
      // {
      //   path: 'newStudent',
      //   name: 'newStudent',
      //   component: () => import(  webpackChunkName:'newStudent' '@/pages/newStudent/newStudent'),
      //   meta: {
      //     title: '',
      //     requireAuth: true
      //   }
      // },
      // 报告详情
      {
        path: 'reportDetail',
        name: 'reportDetail',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/reportDetail/reportDetail'),
        meta: {
          title: '练习报告',
          requireAuth: true
        },
      },
      // 作业
      {
        path: 'homeworkReportDetail',
        name: 'homeworkReportDetail',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/homeworkReportDetail/homeworkReportDetail'),
        meta: {
          title: '作业报告',
          requireAuth: true
        },
      },
      // 学生作业报告
      {
        path: 'studentHomeworkReportDetail',
        name: 'studentHomeworkReportDetail',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/studentHomeworkReportDetail/studentHomeworkReportDetail'),
        meta: {
          title: '作业报告详情',
          requireAuth: true
        },
      }
    ]
  },
  // 旧页面
  {
    path: '/old/',
    name: 'old',
    component: oldPage,
    meta: {
      title: '',
      requireAuth: true
    },
    children:[
      // 为old没值时
      {
        path: '',
        component: () => import( /* webpackChunkName:'courseManagement'*/ '@/pages/courseManagement/courseManagement')
      },
      // 课节
      {
        path: 'courseManagement',
        name: 'courseManagement',
        component: () => import( /* webpackChunkName:'courseManagement'*/ '@/pages/courseManagement/courseManagement'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 添加课节
      {
        path: 'addCourses',
        name: 'addCourses',
        component: () => import( /* webpackChunkName:'addCourses'*/ '@/pages/addCourses/addCourses'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 搜索页面
      {
        path: 'allSearch',
        name: 'allSearch',
        component: () => import( /* webpackChunkName:'allSearch'*/ '@/pages/allSearch/allSearch'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 编辑学员
      {
        path: 'editStudent',
        name: 'editStudent',
        component: () => import( /* webpackChunkName:'editStudent'*/ '@/pages/editStudent/editStudent'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 编辑教师
      {
        path: 'editTeacher',
        name: 'editTeacher',
        component: () => import( /* webpackChunkName:'editTeacher'*/ '@/pages/editTeacher/editTeacher'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 创建班级
      {
        path: 'bianJi',
        name: 'establishClass',
        component: () => import( /* webpackChunkName:'bianJi'*/ '@/pages/bianJi/bianJi'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 财务详情
      {
        path: 'financeDetails',
        name: 'financeDetails',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/financeDetails/financeDetails'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 财务
      {
        path: 'financeMessages',
        name: 'financeMessages',
        component: () => import( /* webpackChunkName:'financeMessages'*/ '@/pages/financeMessages/financeMessages'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 全部课节
      {
        path: 'allCourse',
        name: 'allCourse',
        component: () => import( /* webpackChunkName:'allCourse'*/ '@/pages/allCourse/allCourse'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 财务详情
      {
        path: 'financeDetails',
        name: 'financeDetails',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/financeDetails/financeDetails'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 财务详情
      {
        path: 'financeDetails',
        name: 'financeDetails',
        component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/financeDetails/financeDetails'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 邀请二维码
      {
        path: 'oldInvitationCode',
        name: 'oldInvitationCode',
        component: () => import( /* webpackChunkName:'newInvitationCode'*/ '@/pages/oldInvitationCode/oldInvitationCode'),
        meta: {
          title: '个人中心',
          requireAuth: true
        }
      },
      // 我的
      {
        path: 'oldPersonalCenter',
        name: 'oldPersonalCenter',
        component: () => import( /* webpackChunkName:'newPersonalCenter'*/ '@/pages/oldPersonalCenter/oldPersonalCenter'),
        meta: {
          title: '个人中心',
          requireAuth: true
        }
      },
      // 消息
      {
        path: 'oldPushMessage',
        name: 'oldPushMessage',
        component: () => import( /* webpackChunkName:'newPushMessage'*/ '@/pages/oldPushMessage/oldPushMessage'),
        meta: {
          title: '个人中心',
          requireAuth: true
        }
      },
      // 学员
      {
        path: 'oldStudent',
        name: 'oldStudent',
        component: () => import( /* webpackChunkName:'newStudent'*/ '@/pages/oldStudent/oldStudent'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 快速创建班级
      {
        path: 'quickCreation',
        name: 'quickCreation',
        component: () => import( /* webpackChunkName:'quickCreation'*/ '@/pages/quickCreation/quickCreation'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
      // 作业
      {
        path: 'studentWork',
        name: 'studentWork',
        component: () => import( /* webpackChunkName:'courseManstudentWorkagement'*/ '@/pages/studentWork/studentWork'),
        meta: {
          title: '',
          requireAuth: true
        }
      },
    ]
  },
  // 校验成功
  {
    path: '/successful',
    name: 'successful',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/checkPage/successful'),
    meta: {
      title: '',
    }
  },
  // 客服临时放行
  {
    path: '/supportUnlock',
    name: 'supportUnlock',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/checkPage/supportUnlock'),
    meta: {
      title: '客服临时放行',
    }
  },
  // 客服临时合作地址
  {
    path: '/temporaryLocation',
    name: 'temporaryLocation',
    component: () => import( /* webpackChunkName:'exerciseReport'*/ '@/pages/checkPage/temporaryLocation'),
    meta: {
      title: '客服临时合作地址',
    }
  },
];
if(/new/i.test(location.href)){
  setTeacherLoginState(1)
}else if(/old/i.test(location.href)){
  setTeacherLoginState(0)
}

if(getTeacherLoginState() === '1'){
  routes[0].redirect = '/new/report'
}else {
  routes[0].redirect = '/old/courseManagement'
}
const router = new Router({
  routes
});
// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  console.log("router.beforeEach");
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (getTeacherToken()) {
      next();
    } else {
      const loginState = resolveTeacherLoginState(to.path);
      rememberTeacherLoginRedirect(to.fullPath);
      next({
        path: getTeacherLoginPath(loginState),
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js